import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ObjectTypeEnumText } from "../models/ObjectTypeEnum";
import { PermmisionPostsTypeEnum, PermmisionPostsTypeEnumText } from "../models/PermmisionPostsTypeEnum";
import { TargetObjectIdEnum } from "../models/TargetObjectIdEnum";
import { postsApi } from "../../../utils";
import checkIcon from '../assests/check.png'
import classes from './SendLink.module.css';
import DynamicMessage from "./Popups/DynamicMessage/DynamicMessage";
import SuccessProjectPopup from "./Popups/SuccessProjectPopup/SuccessProjectPopup";
import { DynamicMessageTypeEnum } from "../models/DynamicMessageTypeEnum";
import { throwApiError } from "../store/error-handling-actions";

const SendLink = ({ setMessage, project, saveVersion }) => {

    const texts = useSelector(state => state.translate.texts);
    const homeUrl = useSelector(state => state.application.homeUrl);
    const studyGroup = useSelector(state => state.topics.studyGroup);
    const user = useSelector(state => state.auth.user);
    const { uiData } = useSelector((state) => state.general);
    const [postId, setPostId] = useState(null);
    const [linkCopied, setLinkCopied] = useState(false);
    const [popup, setPopup] = useState(null);
    const [load, setLoad] = useState(false);
    const dispatch = useDispatch();

    const urlProjectRunner = `${window.location.origin}${uiData.baseName}${homeUrl}/projectRunner/`;
    const urlProjectRunnerAndCode = `${window.location.origin}${uiData.baseName}${homeUrl}/projectCode/`;

    useEffect(() => {
        if (saveVersion) {
            setPopup(<DynamicMessage
                type={DynamicMessageTypeEnum.Warn}
                title={texts.saveProject}
                content={texts.MessageContentSaveProjectWarn}
                cancelFunc={() => { setPopup(null); setMessage(null) }}
                confirmFunc={() => {
                    saveVersion(() => {
                            getPostId();
                    }, setLoad);
                }
                } />)
        }
        else {
            getPostId();
        }
    }, [])

    function updateContentPost(dataPost) {
        postsApi.postsUpdateContentIdPost(dataPost?.id, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: "error in updateContentPost", error: error, statusCode: response?.statusCode, message: "postsUpdateContentIdPost " + error.message, level: 1, component: "SendLink", line: 45 }))
            }
            else {
                console.log("updateContentPost");
            }
        })
    }

    const getPostId = () => {
        setLoad(true)
        setPopup(null);
        const data1 = {
            refObjectId: project?.id,
            refObjectType: ObjectTypeEnumText.Project,
            sourceObjectId: user.id,
            sourceObjectType: ObjectTypeEnumText.User,
            targetObjectId: TargetObjectIdEnum.External,
            targetObjectType: ObjectTypeEnumText.ConstUserGroup
        }
        postsApi.postsFilterRangePost({ postsRangeFilter: data1 }, (error1, resdata1, response1) => {
            if (error1) {
                setLoad(false)
                console.log('error in postsFilterRangePost', error1)
            }
            else {
                if (resdata1?.[0]?.id) {
                    setLoad(false)
                    setPostId(resdata1[0].id);
                    if (resdata1[0].hasChange) {
                        updateContentPost(resdata1[0])
                    }
                }
                else {
                    let data2 = {
                        name: project?.name,
                        refObjectId: project?.id,
                        refObjectType: ObjectTypeEnumText.Project,
                        targetObjectType: ObjectTypeEnumText.ConstUserGroup,
                        studyGroupId: studyGroup.id,
                        shares: [
                            {
                                targetObjectId: TargetObjectIdEnum.External,
                                permissionMask: PermmisionPostsTypeEnumText.RunnerAndCode
                            }
                        ]
                    }
                    postsApi.postsAddPost({ postAddInput: data2 }, (error2, resdata2, response2) => {
                        if (error2) {
                            setLoad(false)
                            console.log("error in postsAddPost", error2);
                        }
                        else {
                            setLoad(false)
                            setPostId(resdata2.id);
                        }
                    })
                }
            }
        })
    }

    const copyLink = (url) => {
        console.log("🚀 ~ copyLink ~ url:", url)
        navigator.clipboard.writeText(url);
        setLinkCopied(true);
    }

    return (
        <>
            {load ?
                <div className={classes.Loader}></div>
                :
                <>  {popup}
                    {postId && <SuccessProjectPopup close={() => setMessage(false)} color="#CCF0F0" title={texts.sendProject}>
                        <div className={classes.SendLink}>
                            <div className={classes.SuccessIconAndText}>
                                {linkCopied && <>
                                    <img src={checkIcon} className={classes.SuccessIcon} alt='copied' />
                                    <p className={classes.SuccessText}>{texts.theLinkExcutedAndCopied}</p>
                                </>}
                            </div>
                            <div>
                                <div>{texts.copyLinkToCode}</div>
                                <div className={classes.CopyLinkContainer}>
                                    <div className={classes.Link}>{urlProjectRunnerAndCode + postId}</div>
                                    <button className={classes.Button} onClick={() => copyLink(urlProjectRunnerAndCode + postId)}>{texts.copyLink2}</button>
                                </div>
                            </div>
                            <div>
                                <div>{texts.copyLinkToViewProject}</div>
                                <div className={classes.CopyLinkContainer}>
                                    <div className={classes.Link}>{urlProjectRunner + postId}</div>
                                    <button className={classes.Button} onClick={() => copyLink(urlProjectRunner + postId)}>{texts.copyLink2}</button>
                                </div>
                            </div>
                        </div>
                    </SuccessProjectPopup>}
                </>}
        </>)
}

export default SendLink;